(function($){
    Drupal.behaviors.table = {
        attach() {

            let tables = $('.ukho-table--scrollable');
            const scrollClass = 'scrollable';

            function checkScrollable(){
                tables.each(function(i, table){
                    const isScrollable = table.scrollWidth > table.clientWidth;

                    if (isScrollable){
                        $(table).addClass(scrollClass);
                    } else {
                        $(table).removeClass(scrollClass);
                    }
                });
            }

            $(window).resize(function() {
                clearTimeout($.data(this, 'resizeTimer'));
                $.data(this, 'resizeTimer', setTimeout(function() {
                    checkScrollable();
                }, 200));
                // Debounced to reduce amount of invocations
            });

            checkScrollable();
        }
    };
})(jQuery);
